import { FC, useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { useAppStore } from "store";
import { getAuthorsOptions, IOptionsItem, searchStyleSheet } from "helpers/select.helper";
import DateFilter from "components/partial/filters/date-filter/date-filter";
import MultiSelectFilter from "components/partial/filters/select-filter/multi-select-filter";
import { getGroupSearchInitParams } from "helpers/filter.helper";
import SearchClearButton from "./filter-clear-button";
import { observer } from "mobx-react";
import isEqual from "lodash/isEqual";
import { useAdvSearch } from "hooks/useAdvSearch";
import { IDefaultFilter } from "./data";

interface IAdvSearchFilterProps extends IDefaultFilter {}

interface IAdvFilterOptions {
	authors?: IOptionsItem[];
}

const AdvSearchGroupFilters: FC<IAdvSearchFilterProps> = ({ className }) => {
	const [filtersOptions, setFilterOptions] = useState<IAdvFilterOptions>({} as IAdvFilterOptions);
	const { searchStore, toasterStore } = useAppStore();
	const [isClear, setIsClear] = useState(false);
	const hasFilters = !isEqual(getGroupSearchInitParams(), searchStore.params) || searchStore.groupsResult.length;

	useEffect(() => {
		searchStore
			.getGroupCreators()
			.then((authors) => {
				setFilterOptions((prevState) => ({
					...prevState,
					authors: getAuthorsOptions(authors),
				}));
			})
			.catch((error) => toasterStore.showErrorMessage(error));
	}, [searchStore, toasterStore]);

	const { setParams } = useAdvSearch(getGroupSearchInitParams);

	return (
		<div className={classNames(styles.adv_search_filter__row, className)}>
			<MultiSelectFilter
				containerClassName={styles.adv_search_filter__select_container}
				customStyles={searchStyleSheet}
				className={styles.adv_search_filter__col}
				params={searchStore.params}
				setParams={setParams}
				label="Creator"
				options={filtersOptions.authors ?? []}
				propertyName="CreatorId"
				isClear={isClear}
			/>

			<DateFilter
				className={styles.adv_search_filter__select_container}
				buttonClassName={styles.adv_search_filter__col}
				params={searchStore.params}
				setParams={setParams}
				label="Last updated"
				propertyName="UpdatedUtc"
				isClear={isClear}
			/>

			{hasFilters && <SearchClearButton setIsClear={setIsClear} getInitParams={getGroupSearchInitParams} />}
		</div>
	);
};

export default observer(AdvSearchGroupFilters);
